module.exports = __webpack_public_path__ + "assets/img/title-dfa44dc9.png";